import type { FaireProductEntity } from "../../entity_types/product";

export const p_g8f4yuznur: FaireProductEntity = {
  token: "p_g8f4yuznur",
  type: "product",
  name: "Women Waterproof Crossbody Gym Yoga Shoulder Bag",
  brandToken: "b_fj2hyk2c4h",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d68b526d7fa5fe7c7c833f90c65cce8da295618e2498fd291d8705f0ed90779b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/403e86e689d194e3ba79e95f0e09dbb1a43404c7be42c278bda2fa37ee02818c.jpeg",
    "https://cdn.faire.com/fastly/2b4d6e3bd6ed9c7c4fbb708d8c262d3ddaa8deec0c52f7032557581996cd0705.jpeg",
    "https://cdn.faire.com/fastly/bf551fe9a0b998a914026f26cb21974b80428c5a9a5848cda36f64bee47676a5.jpeg",
    "https://cdn.faire.com/fastly/3d485704b563b15211863e358d20d85dcd5b1e04953b80a45f0472a9d7949415.jpeg",
    "https://cdn.faire.com/fastly/6c4eb3b1932c52824c748336284c1ce1b346264735ce6c673f80231523a1d746.jpeg",
    "https://cdn.faire.com/fastly/791585a79c7e4be992180004d640d480218a4f72dc2b29f22c8edb5cf3210f26.jpeg",
    "https://cdn.faire.com/fastly/8be1cf82f6cfacd4554b215a66802d8b5e3127abbb0603c94170214e40a948f8.jpeg",
    "https://cdn.faire.com/fastly/a0cd90dbed8ee07749142d2bfb2b2f8911c507341c19e0c2be9ff54d1a4c2a67.jpeg",
    "https://cdn.faire.com/fastly/98862d5a993bf0a5251980d472f0b4596e94d72669ec0ec268473e98c4bd162f.jpeg",
    "https://cdn.faire.com/fastly/fc8b284e928e2f76a414a4dec335396beb8333551b4b0c6d2843dff8786c8006.jpeg",
  ],
  priceDollars: 21.61,
  description:
    "Pattern Type: Plain\nDetails: Internal Compartments + Wide Shoulder Strap + Water-Resistant Exterior\nType: Sports &amp; Casual Crossbody Bag\nMaterial:\n\nOuter: 100% Nylon (Taslon Waterproof Coating)\nLining: 100% Polyester (Waterproof) Features:\nInternal snap-button compartments prevent contents from spilling\nOversized main compartment with multiple pockets for versatile storage\nPadded wide shoulder strap ensures comfortable carrying\nReinforced stitching at stress points for durability\nFabric Properties:\n\nWater-repellent surface beads up liquid droplets\nFour-way stretch fabric maintains shape\nBreathable construction prevents moisture buildup\nAbrasion-resistant exterior withstands daily use\nCare Instructions: Hand Wash in Cold Water (30°C max), Use Laundry Bag, Do Not Bleach, Lay Flat to Dry, Low Ironing, Dry Cleaning Allowed, Wash Dark Colors Separately\n\nThe clothes are made of high quality fabric, it will not be very transparent, no embarrassing lines.",
  tags: [],
  msrpDollars: 43.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:41.387Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
